import { Input, Space, Table, Popconfirm } from 'antd';
import { EditFilled, DeleteFilled, SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import ResultError from '../../../../static-pages/ResultError';
import { useQuery, gql } from '@apollo/client';

const GET_BANS = gql`
  query GetBans {
    bans {
      id
      steamHex
      fivemHex
      reason
      timestamp
      expire
    }
  }
`;

function App() {
  const { data, error, loading: isFetching } = useQuery(GET_BANS);

  const [bans, setBans] = useState([]);
  const [searchText, setSearchText] = useState('');

  const handleDelete = (key) => {
    console.log(key);
  }

  useEffect(() => {
    if (!isFetching && data) {
      if (data.bans) {
        setBans(data.bans);
      } else {
        setBans([]);
      }
    }
  }, [data, isFetching]);

  useEffect(() => {
    if (searchText && (data && data.bans)) {
      const filteredBans = data.bans.filter((ban) => {
        return (ban?.steamHex?.toLowerCase().includes(searchText.toLowerCase())
          || ban?.reason?.toLowerCase().includes(searchText.toLowerCase())
          || ban?.fivemHex?.toLowerCase().includes(searchText.toLowerCase()));
      });
      setBans(filteredBans);
    } else {
      setBans(data?.bans);
    }
  }, [searchText, data]);

  const columns = [
    {
      title: 'Steam Hex',
      dataIndex: 'steamHex',
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
    },
    {
      title: 'Date',
      dataIndex: 'timestamp',
      render: (timestamp) => new Date(parseInt(timestamp)).toLocaleString(),
    },
    {
      title: 'Expires',
      dataIndex: 'expire',
      render: (expire) => new Date(expire * 1000).toLocaleString(),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      align: 'center',
      width: '5%',
      render: (_, record) =>
        bans.length >= 1 ? (
          <Space>
            <Popconfirm title="Edit coming soon" onConfirm={() => handleDelete(record.key)}>
              <EditFilled />
            </Popconfirm>
            <Popconfirm title="Do you want to delete this record?" onConfirm={() => handleDelete(record.key)}>
              <DeleteFilled />
            </Popconfirm>
          </Space>
        ) : null,
    }
  ];

  const onTableChange = (pagination, filters, sorter, extra) => {
    console.log(pagination, filters, sorter, extra)
  }

  if (!isFetching && error) {
    return (
      <ResultError title="Error Fetching Bans" text={`There was an error fetching the ban list`} />
    )
  }

  return (
    <Space direction='vertical' style={{ width: '100%' }}>
      <div>
        <h1>Bans</h1>
        <p>List of all banned players</p>
      </div>
      <Input
        type="text"
        value={searchText}
        prefix={<SearchOutlined />}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search"
        style={{ width: '300px' }}
      />
      <Table
        width="100%"
        columns={columns}
        dataSource={bans}
        loading={isFetching}
        rowKey="id"
        onChange={onTableChange}
      />
    </Space>
  );
}

export default App;
